<template>
  <div class="h-100">
    <fb-pages-box
      :show-no-pages="showNoPages"
      :show-no-thing="showNoThing"
      :pages="pages"
      :invalid-page-ids="invalidPageIds"
    />
    <instagram-accounts-box
      v-if="showInstagram"
      :show-no-account="showNoAccounts"
      :show-no-thing="showNoThing"
      :accounts="accounts"
      :invalid-account-ids="invalidAccountIds"
    />
    <no-account-page v-if="showNoThing" />
    <div class="mb-4" />

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import NoAccountPage from '@/views/dashboard/components/NoAccountPage'
import FbPagesBox from '@/views/dashboard/components/FbPagesBox'
import InstagramAccountsBox from '@/views/dashboard/components/InstagramAccountsBox'
import PageApi from '@/api/page'
import InstagramAccountsApi from '@/api/instagram/account'

export default {
  components: {
    InstagramAccountsBox,
    FbPagesBox,
    NoAccountPage,
  },
  data() {
    return {
      invalidPageIds: [],
      invalidAccountIds: [],
    }
  },
  computed: {
    ...mapGetters({
      pages: 'pages/pages',
      accounts: 'instagram/accounts',
      showInstagram: 'auth/showInstagram',
    }),
    showNoThing() {
      return !this.pages.length && !this.accounts.length
    },
    showNoAccounts() {
      return !this.showNoThing && !this.accounts.length
    },
    showNoPages() {
      return !this.showNoThing && !this.pages.length
    },
  },
  watch: {
    pages: {
      immediate: false,
      handler(val) {
        if (val?.length && !this.invalidPageIds.length) {
          PageApi.checkTokens()
            .then(res => { this.invalidPageIds = res.invalid_ids || [] })
            .catch(() => {})
        }
      },
    },
    accounts: {
      immediate: false,
      handler(val) {
        if (this.showInstagram && val?.length && !this.invalidAccountIds.length) {
          InstagramAccountsApi.checkTokens()
            .then(res => { this.invalidAccountIds = res.invalid_ids || [] })
            .catch(() => {})
        }
      },
    },
  },
  mounted() {
    this.checkTokensInBackground()
  },
  methods: {
    async checkTokensInBackground() {
      const tasks = []
      if (this.pages.length) {
        tasks.push(
          PageApi.checkTokens()
            .then(res => {
              this.invalidPageIds = res.invalid_ids || []
            })
            .catch(() => {}),
        )
      }
      if (this.showInstagram && this.accounts.length) {
        tasks.push(
          InstagramAccountsApi.checkTokens()
            .then(res => {
              this.invalidAccountIds = res.invalid_ids || []
            })
            .catch(() => {}),
        )
      }
      if (tasks.length) {
        await Promise.all(tasks)
      }
    },
  },
}
</script>
